/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptSegmentMapping } from '../models/V3StackAdaptSegmentMapping';
import { HttpFile } from '../http/http';

/**
* A map of all segment ids on the campaign to their stackadapt ids and include vs exclude
*/
export class V3StackAdaptSegmentMap {
    /**
    * Segments to include
    */
    'includeSegments'?: Array<V3StackAdaptSegmentMapping>;
    /**
    * Segments to exclude
    */
    'excludeSegments'?: Array<V3StackAdaptSegmentMapping>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "includeSegments",
            "baseName": "include_segments",
            "type": "Array<V3StackAdaptSegmentMapping>",
            "format": ""
        },
        {
            "name": "excludeSegments",
            "baseName": "exclude_segments",
            "type": "Array<V3StackAdaptSegmentMapping>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptSegmentMap.attributeTypeMap;
    }

    public constructor() {
    }
}

